import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7008eda3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card p-4" }
const _hoisted_2 = { class: "d-flex gap-4 align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<svg width=\"43\" height=\"45\" viewBox=\"0 0 43 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-7008eda3><rect width=\"42.4652\" height=\"45\" rx=\"10\" fill=\"#F9F9F9\" data-v-7008eda3></rect><g clip-path=\"url(#clip0_3443_1516)\" data-v-7008eda3><path opacity=\"0.5\" d=\"M27.4786 21.3258L20.0412 13.0492C19.7252 12.6975 19.2967 12.5 18.8498 12.5H11.6849C10.7543 12.5 10 13.3395 10 14.375V22.3484C10 22.8456 10.1775 23.3226 10.4935 23.6742L17.9309 31.9508C18.5889 32.683 19.6557 32.6831 20.3137 31.9508L27.4786 23.9775C28.1366 23.2452 28.1366 22.058 27.4786 21.3258ZM13.9314 18.75C13.0009 18.75 12.2465 17.9105 12.2465 16.875C12.2465 15.8395 13.0009 15 13.9314 15C14.862 15 15.6163 15.8395 15.6163 16.875C15.6163 17.9105 14.862 18.75 13.9314 18.75ZM31.9717 23.9775L24.8067 31.9508C24.1488 32.683 23.082 32.683 22.424 31.9508L22.4113 31.9368L28.5211 25.1376C29.1178 24.4736 29.4464 23.5907 29.4464 22.6516C29.4464 21.7126 29.1178 20.8297 28.5211 20.1657L21.6326 12.5H23.3428C23.7897 12.5 24.2182 12.6975 24.5342 13.0492L31.9717 21.3258C32.6296 22.058 32.6296 23.2452 31.9717 23.9775Z\" fill=\"#203972\" data-v-7008eda3></path><path d=\"M27.4786 21.3258L20.0412 13.0492C19.7252 12.6975 19.2967 12.5 18.8498 12.5H11.6849C10.7543 12.5 10 13.3395 10 14.375V22.3484C10 22.8456 10.1775 23.3225 10.4935 23.6742L17.9309 31.9508C18.5889 32.683 19.6557 32.6831 20.3137 31.9508L27.4786 23.9775C28.1366 23.2452 28.1366 22.058 27.4786 21.3258ZM13.9314 18.75C13.0009 18.75 12.2465 17.9105 12.2465 16.875C12.2465 15.8395 13.0009 15 13.9314 15C14.862 15 15.6163 15.8395 15.6163 16.875C15.6163 17.9105 14.862 18.75 13.9314 18.75Z\" fill=\"#203972\" data-v-7008eda3></path></g><defs data-v-7008eda3><clipPath id=\"clip0_3443_1516\" data-v-7008eda3><rect width=\"22.4652\" height=\"25\" fill=\"white\" transform=\"translate(10 10)\" data-v-7008eda3></rect></clipPath></defs></svg>", 1)
const _hoisted_4 = { class: "m-0 subtitulo cor_texto_1" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "p-5 lista col-6" }
const _hoisted_7 = { class: "d-flex mb-3 flex-column gap-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Óleo do motor", -1))
const _hoisted_9 = { class: "col-12 d-flex flex-row gap-3" }
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-pencil-alt" }, null, -1))
const _hoisted_12 = { class: "d-flex mb-3 flex-column gap-1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Filtro de Óleo ", -1))
const _hoisted_14 = { class: "col-12 d-flex flex-row gap-3" }
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"18px"},
  class: "m-0 fas fa-pencil-alt"
}, null, -1))
const _hoisted_17 = { class: "d-flex mb-3 flex-column gap-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Filtro de Ar", -1))
const _hoisted_19 = { class: "col-12 d-flex flex-row gap-3" }
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-pencil-alt" }, null, -1))
const _hoisted_22 = { class: "d-flex mb-3 flex-column gap-1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Filtro de Cabine", -1))
const _hoisted_24 = { class: "col-12 d-flex flex-row gap-3" }
const _hoisted_25 = ["value"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-pencil-alt" }, null, -1))
const _hoisted_27 = { class: "d-flex mb-3 flex-column gap-1" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Filtro de Combustivel", -1))
const _hoisted_29 = { class: "col-12 d-flex flex-row gap-3" }
const _hoisted_30 = ["value"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-pencil-alt" }, null, -1))
const _hoisted_32 = { class: "d-flex mb-3 flex-column gap-1" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Pneu", -1))
const _hoisted_34 = { class: "col-12 d-flex flex-row gap-3" }
const _hoisted_35 = ["value"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "m-0 fas fa-pencil-alt" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfigMarcasDragAndDropVue = _resolveComponent("ConfigMarcasDragAndDropVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_4, "Marcas Parceiras " + _toDisplayString(_ctx.marca), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("input", {
              style: {"background-color":"#f5f7fa","padding-left":"13px","border":"1px solid #e4e7ed","color":"black"},
              class: "col-8 rounded-1 texto",
              value: `${_ctx.marcasParceirasTotalCount.oleos} selecionados`,
              disabled: ""
            }, null, 8, _hoisted_10),
            _createVNode(_component_Button, {
              variant: "primary",
              text: "Editar",
              "data-title": "Editar Óleo do motor",
              onClick: _cache[0] || (_cache[0] = ($event: any) => { _ctx.setModalTitle($event); _ctx.sendArrayCorrectly('oleos');})
            }, {
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("li", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("input", {
              style: {"background-color":"#f5f7fa","padding-left":"13px","border":"1px solid #e4e7ed","color":"black"},
              class: "col-8 rounded-1 texto",
              value: `${_ctx.marcasParceirasTotalCount.filtroOleo} selecionados`,
              disabled: ""
            }, null, 8, _hoisted_15),
            _createVNode(_component_Button, {
              variant: "primary",
              text: "Editar",
              "data-title": "Editar Filtro de Óleo ",
              onClick: _cache[1] || (_cache[1] = ($event: any) => { _ctx.setModalTitle($event); _ctx.sendArrayCorrectly('filtroOleo');})
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("li", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("input", {
              style: {"background-color":"#f5f7fa","padding-left":"13px","border":"1px solid #e4e7ed","color":"black"},
              class: "col-8 rounded-1 texto",
              value: `${_ctx.marcasParceirasTotalCount.filtroAr} selecionados`,
              disabled: ""
            }, null, 8, _hoisted_20),
            _createVNode(_component_Button, {
              variant: "primary",
              text: "Editar",
              "data-title": "Editar Filtro de Ar",
              onClick: _cache[2] || (_cache[2] = ($event: any) => { _ctx.setModalTitle($event); _ctx.sendArrayCorrectly('filtroAr');})
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("li", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("input", {
              style: {"background-color":"#f5f7fa","padding-left":"13px","border":"1px solid #e4e7ed","color":"black"},
              class: "col-8 rounded-1 texto",
              value: `${_ctx.marcasParceirasTotalCount.filtroCabine} selecionados`,
              disabled: ""
            }, null, 8, _hoisted_25),
            _createVNode(_component_Button, {
              variant: "primary",
              text: "Editar",
              "data-title": "Editar Filtro de Cabine",
              onClick: _cache[3] || (_cache[3] = ($event: any) => { _ctx.setModalTitle($event); _ctx.sendArrayCorrectly('filtroCabine');})
            }, {
              default: _withCtx(() => [
                _hoisted_26
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("li", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("input", {
              style: {"background-color":"#f5f7fa","padding-left":"13px","border":"1px solid #e4e7ed","color":"black"},
              class: "col-8 rounded-1 texto",
              value: `${_ctx.marcasParceirasTotalCount.filtroCombustivel} selecionados`,
              disabled: ""
            }, null, 8, _hoisted_30),
            _createVNode(_component_Button, {
              variant: "primary",
              text: "Editar",
              "data-title": "Filtro de Combustivel",
              onClick: _cache[4] || (_cache[4] = ($event: any) => { _ctx.setModalTitle($event); _ctx.sendArrayCorrectly('filtroCombustivel');})
            }, {
              default: _withCtx(() => [
                _hoisted_31
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("li", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("input", {
              style: {"background-color":"#f5f7fa","padding-left":"13px","border":"1px solid #e4e7ed","color":"black"},
              class: "col-8 rounded-1 texto",
              value: `${_ctx.marcasParceirasTotalCount.pneus} selecionados`,
              disabled: ""
            }, null, 8, _hoisted_35),
            _createVNode(_component_Button, {
              variant: "primary",
              text: "Editar",
              "data-title": "Editar Pneu",
              onClick: _cache[5] || (_cache[5] = ($event: any) => { _ctx.setModalTitle($event); _ctx.sendArrayCorrectly('pneus');})
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(_component_ConfigMarcasDragAndDropVue, {
        class: "col-6",
        produtos: _ctx.propDragDrop,
        onFecharModal: _ctx.closeModal,
        onAtualizarNumeros: _ctx.attSelecionados,
        onAttLista: _ctx.atualizarListaReordenada
      }, null, 8, ["produtos", "onFecharModal", "onAtualizarNumeros", "onAttLista"])
    ])
  ]))
}